/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LvItem = {
    readonly id: string;
    dataflor_id: string;
    parent_dataflor_id: string | null;
    reference_dataflor_id: string | null;
    kind: LvItem.kind;
    postyp: string;
    number: string | null;
    text: string | null;
    minutes: string;
    minutes_total: string;
    depth: number;
    sequence: number;
};
export namespace LvItem {
    export enum kind {
        TITLE = 'title',
        POSITION = 'position',
        TEXT = 'text',
        UNKNOWN = 'unknown',
    }
}

